import type { ReactNode } from 'react'
import styled from 'styled-components'
import CorporateEventPartnershipBanner from './CorporateEventLandingPage/CorporateEventPartnershipBanner'
import CorporateEventNavbar from './CorporateEventLandingPage/CorporateEventNavbar'

const StickyHeader = styled.div`
  position: sticky;
  top: 0;
  z-index: 100;
`

interface Props {
  eventId: string
  regionCode: string
  children: ReactNode
}

function CorporateEventLayout({ eventId, regionCode, children }: Props) {
  return (
    <>
      <StickyHeader>
        <CorporateEventPartnershipBanner />
        <CorporateEventNavbar eventId={eventId} regionCode={regionCode} />
      </StickyHeader>
      {children}
    </>
  )
}

export default CorporateEventLayout
